import React, {createRef, useState, useContext, Fragment, useEffect} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import MaterialTable from "@material-table/core";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../../controls/Material-Table-Components';
import { Checkbox, useTheme } from "@material-ui/core";
import { v4 as uuidv4 } from 'uuid';

import SystemContext from "../../../../SystemContext";
import {ColumnWidth, ValidatorColumn} from "../../../../blocks/ColumnHelper";
import ServicesEditorValidator from "../../validators/ServicesEditorValidator";
import CompanyUuidLookup from "../../../Companies/components/CompanyUuidLookup";
import AirportFuelSupplierLookup from "../../../Companies/components/AirportFuelSupplierLookup";


const ServicesEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('Services.AddFunction', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const props = {
    ..._props
  }
  const {classes, flightRecord, outboundAirport} = props;
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const airportServices = (flightRecord.services ? flightRecord.services[`${outboundAirport?"outbound":"inbound"}`] : null);

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(ServicesEditorValidator, false);

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(200,6,undefined,undefined,undefined,undefined,false),
        title: "Service",
        field: "serviceName",
        editable: "never",
      },
      {
        ...baseColumn,
        ...ColumnWidth(90,2,undefined,undefined,undefined,undefined,false),
        title: "Required",
        field: "isRequired",
        emptyValue: rowData =>
          <Checkbox
            style={ rowData.optional ? {padding: 0, color: theme.palette.primary.main} : {padding: 0, color: '#b3b0b0'}}
            checked={rowData.isRequired===null?rowData.requiredDefault===1:(rowData.isRequired === 1 || rowData.isRequired === true) ?? true}
          />,
        initialEditValue: false,
        type: "boolean",
        editable: ((cell, rowData, updateData) => { return Boolean(rowData.optional) }),
        render: rowData =>
          <Checkbox
            style={ rowData.optional ? {padding: 0, color: theme.palette.primary.main} : {padding: 0, color: '#b3b0b0'}}
            checked={rowData.isRequired === null ? rowData.requiredDefault === 1 : (rowData.isRequired === 1 || rowData.isRequired === true) ?? true}
          />,
        editComponent: props =>
          <Checkbox
            style={{padding: 0, color: theme.palette.primary.main}}
            checked={props.rowData.isRequired ===null ? props.rowData.requiredDefault === 1: (props.rowData.isRequired === 1 || props.rowData.isRequired === true) ?? true}
            onChange={ (event, checked) => {
              props.onChange(checked);
            }}
          />
      },
      {
        ...baseColumn,
        ...ColumnWidth(400,2,undefined,undefined,undefined,undefined,false),
        title: "Service Provider",
        field: "serviceProviderUuid",
        editable: (cell, rowData, updateData) => { return (updateData.isRequired ===null ? updateData.requiredDefault === 1 : updateData.isRequired === 1 || updateData.isRequired === true)},
        editComponent: (props) => {
          return(
            props.rowData.serviceCode === "FUELING"
              ?
                <AirportFuelSupplierLookup
                  returnType="object"
                  value={props.value}
                  airportCode={flightRecord.originAirportCode}
                  onChange={(returnObject) => {
                    if (returnObject.found) {
                      const fuelSupplier = returnObject.data;
                      if (!__.isEmpty(fuelSupplier) && fuelSupplier.companyName !== props.rowData.companyName) {
                        const data = {
                          ...props.rowData,
                          serviceProviderUuid: fuelSupplier.companyUuid,
                          serviceProviderName: fuelSupplier.companyName,
                          isRequired: true
                        }
                        props.onRowDataChange(data);
                      }
                    } else {
                      props.onChange(returnObject.value);
                    }
                  }}
                />
              :
                <CompanyUuidLookup
                  companyType={props.rowData.companyType}
                  value={props.value}
                  returnType={"object"}
                  atAirport={outboundAirport ? flightRecord.originAirportCode : flightRecord.destinationAirportCode}
                  role={props.rowData.companyRole}
                  onChange={(returnObject) => {
                    if (returnObject.found) {
                      const contractedParty = returnObject.data
                      const data = {
                        ...props.rowData,
                        serviceProviderName: contractedParty.companyName,
                        serviceProviderUuid: contractedParty.companyUuid,
                        isRequired: true
                      }
                      props.onRowDataChange(data);
                    } else {
                      props.onChange(returnObject.value);
                    }
                  }}
                />
          )
        },
        render: (rowData) => (
          rowData.serviceCode === "FUELING"
            ?
              <AirportFuelSupplierLookup
                returnType="object"
                value={rowData.serviceProviderUuid}
                airportCode={flightRecord.originAirportCode}
                type={"render"}
              />
            :
              <CompanyUuidLookup
                companyType={rowData.companyType}
                value={rowData.serviceProviderUuid}
                returnType={"object"}
                type="render"
                atAirport={outboundAirport ? flightRecord.originAirportCode : flightRecord.destinationAirportCode}
              />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(400,6,undefined,undefined,undefined,undefined,false),
        title: "Notes",
        field: "serviceNotes",
      },
    ];
  };

  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.TripLegEditor}>
          <MaterialTable
            tableRef={tableRef}
            data={airportServices}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              //defaultExpanded: true, // does not work
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
              onEditModeChanged: (editMode)=> {
                if (props.changeButtonState) {
                  const changes = {
                    save: {disabled: false, hidden: false},
                  }
                  if (editMode) {
                    changes['save'] = {disabled: true, hidden: false}
                  }
                  props.changeButtonState(changes);
                }
              },
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={300}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Airport Services"
            columns={getColumns({...props, canEdit: state.canEdit})}
            editable={{
              isEditable: (rowData) => {
                return state.canEdit && (rowData.readOnly !== undefined ? !rowData.readOnly : true);
              },
              isDeletable: (rowData) => {
                return state.canEdit && (rowData.readOnly !== undefined ? !rowData.readOnly : true) && (Boolean(rowData.optional));
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    if (Array.isArray(airportServices)) {
                      airportServices.push({...newData, servicesTypeUuid: uuidv4()});
                      const services = props.flightRecord?.services || {};
                      services[`${outboundAirport?"outbound":"inbound"}`] = airportServices;
                      props.onChange({record: {...props.flightRecord, services: services}, oldRecord: props.flightRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  })
                  : undefined,
              onRowUpdate: state.canEdit
                  ? (newData, oldData) => new Promise((resolve, reject) => {
                      const serviceIdx = __.findIndex(airportServices, {servicesTypeUuid: oldData.servicesTypeUuid});
                      if (serviceIdx >= 0) {
                        airportServices[serviceIdx] = newData;
                        const services = props.flightRecord?.services || {};
                        services[`${outboundAirport?"outbound":"inbound"}`] = airportServices;
                        props.onChange({record: {...props.flightRecord, services: services}, oldRecord: props.flightRecord, resolve, reject});
                      } else {
                        reject();
                      }
                    })
                  : undefined,
              onRowDelete: state.canEdit
                ? (oldData) => new Promise((resolve, reject) => {
                    const serviceIdx = __.findIndex(airportServices, {servicesTypeUuid: oldData.servicesTypeUuid});
                    if (serviceIdx >= 0) {
                      airportServices.splice(serviceIdx, 1);
                      const services = props.flightRecord?.services || {};
                      services[`${outboundAirport?"outbound":"inbound"}`] = airportServices;
                      props.onChange({record: {...props.flightRecord, services: services}, oldRecord: props.flightRecord, resolve, reject});
                    } else {
                      reject();
                    }
                  })
                : undefined,
            }}
        />
      </div>
  );
}

export default ServicesEditor;
